'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BackToTop = require('./components/BackToTop.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BackToTop).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-back-to-top/lib/index.js
// module id = 1029
// module chunks = 1